export default __webpack_public_path__ + "static/dwell-25c5bf3eb57fc0cb2655f26894632cff.png";